import React from 'react'
import styled from 'styled-components';
import blog1 from '../img/blogs/blog1.svg';
import PrimaryButton from './PrimaryButton';

function Dimg() {
    return (
        <DimgStyled>
            <div className="left-content">
                <img src={blog1} alt=""/>
            </div>
            <div className="right-content">
                <h4>Complete React Website with Firebase By <span> Sawraj</span></h4>
                <p className="paragraph">
                After working on ReactJS for so long, It's time to move our knowledge to more advanced part. Where we will see How to Create a Complete Multipage Website using 
React JS and Firebase. Also, how to use the React Hooks and how to use Hooks in our applications. We will go through each concept line by line and understand the meaning and the output of it in a practically manner.

First, I highly recommend you to watch the video and then look for the code and try to do it by yourself. And use the code for reference.
                    
                </p>
                <div className="about-info">
                    <div className="info-title">
                        <p>Name</p>
                        <p>Date</p>
                        <p>Location</p>
                        <p>Tag</p>
                    </div>
                    <div className="info">
                        <p>: Lorem Ipsum</p>
                        <p>: 20 Dec 2022</p>
                        <p>: India </p>
                        
                        <p>: Freelance</p>
                    </div>
                </div>
                <PrimaryButton title={'Download '} />
                <PrimaryButton title={'Share '} />
                
                
                            </div>

                            
        </DimgStyled>
        
    )
}


const DimgStyled = styled.div`
    margin-top: 5rem;
    display: flex;
    @media screen and (max-width:1000px){
        flex-direction: column;
        .left-content{
            margin-bottom: 2rem;
        }
    }
    .left-content{
        width: 100%;
        img{
            width: 95%;
            object-fit: cover;
        }
    }
    .right-content{
        width: 100%;
        h4{
            font-size: 2rem;
            color: var(--white-color);
            span{
                font-size: 2rem;
            }
        }
        .paragraph{
            padding: 1rem 0;
        }
        .about-info{
            display: flex;
            padding-bottom: 1.4rem;
            .info-title{
                padding-right: 3rem;
                p{
                    font-weight: 600;
                }
            }
            .info-title, .info{
                p{
                    padding: .3rem 0;
                }
            }
        }
        
    }
`;
export default Dimg;
